<template>
	<div class="cookie-policy">
		<navComponent/>
		<div class="container" style="margin-bottom: 5%;">
			<div style="margin: 10% 0;"><h1>Cookie Policy</h1></div>
			<p>coming soon</p>
		</div>
		<footerComp/>
	</div>
</template>

<script>
  import navComponent from '@/components/nav.vue'
  import footerComp from '@/components/footer.vue'

  export default {
    name: 'cookie-policy',
    data() {
      return {}
    },
    components: {
      navComponent,
      footerComp
    },
    methods: {}
  }
</script>

